const redirectToMapPortalsList = (prefix: string): void => {
  const currentUrl = new URL(window.location.href);
  const newUrl = `${currentUrl.origin}/${prefix}/`;

  window.location.href = newUrl;
};

export default redirectToMapPortalsList;
